<template>
  <div
    class="sc__systems-transition"
    :class="{ 'product-searching-active': internalProductSearch }"
  >
    <component
      :is="getSubView"
      v-if="getSubView"
    >
      <template #productSearch>
        <label for="productSearch">
          {{ translations.transition.productSearchLabel }}
        </label>
        <ScAutocomplete
          unique-id="productSearch"
          class="sc__systems-transition__content--productSearch-autocomplete"
          item-text="displayName"
          with-free-form
          :error-message="translations.filters.productFilterErrors.productError"
          :aria-label="translations.transition.productSearchLabel"
          :is-error-state="hasErrorFetchingProduct"
          :initial-selected-item="internalSelectedProduct"
          :items="productList"
          :filter="(itemText, searchText) => autocompleteFilterFunc(itemText, searchText)"
          @item-selected="onProductSearchSelected"
          @input="onProductSearchInput"
          @input-cleared="removeProductSelection"
        >
          <template #submitButton>
            <button
              type="submit"
              @click.prevent="onProductSearchSelected(internalProductSearch)"
            >
              <g-icon-arrow-right />
            </button>
          </template>
        </ScAutocomplete>
      </template>
    </component>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss">
  @import './style.scss';
</style>
